import React, { useContext, useCallback } from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';
import { extend } from '@thd-nucleus/data-sources';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { SharebeltContext } from '../../Sharebelt.context';
import ShareBeltTooltip from './ShareBeltTooltip';
import { ProductLoader } from '../../ProductLoader';

const ShareBeltShareButton = ({
  collectionImageSrc,
  email,
  hrefPath,
  pinterestTitle
}) => {

  const {
    channel
  } = useContext(ExperienceContext);
  const { storeId } = useStore();

  const {
    vertical,
    horizontal,
    itemId,
    collectionId
  } = useContext(SharebeltContext);

  let shareButtonTrigger;

  const closeTooltip = useCallback(() => {
    if (shareButtonTrigger) {
      shareButtonTrigger.click();
    }
  }, []);

  const shareBeltButtonClasses = classNames('thd-sharebelt__button', {
    'thd-sharebelt__button--vertical': vertical,
    'thd-sharebelt__button--horizontal': horizontal,
  });

  const shareBeltIconClasses = classNames('thd-sharebelt-icons', 'thd-sharebelt-icons--share', {
    'thd-sharebelt-icons--vertical': vertical,
    'thd-sharebelt-icons--horizontal': horizontal,
  });

  // @todo check mobile requirements
  if (channel.toLowerCase() !== 'desktop') {
    return (
      <div className="thd-sharebelt__item" />
    );
  }

  return (
    <div className="thd-sharebelt__item">
      <Tooltip
        channel="desktop"
        closeButton
        content={(
          <ShareBeltTooltip
            storeId={storeId}
            collectionImageSrc={collectionImageSrc}
            email={email}
            itemId={itemId}
            collectionId={collectionId}
            toolTipClose={closeTooltip}
            hrefPath={hrefPath}
            pinterestTitle={pinterestTitle}
          />
        )}
        placement="bottom"
      >
        <button
          id="thd-sharebelt-sharebutton"
          className={shareBeltButtonClasses}
          type="button"
          ref={(input) => {
            shareButtonTrigger = input;
          }}
        >
          <span className={shareBeltIconClasses}>share</span>
          <span>Share</span>
        </button>
      </Tooltip>
    </div>
  );
};

ShareBeltShareButton.displayName = 'ShareBeltShareButton';

ShareBeltShareButton.dataModel = extend({}, ProductLoader);

ShareBeltShareButton.propTypes = {
  collectionImageSrc: string,
  email: bool,
  hrefPath: string,
  pinterestTitle: string,
};

ShareBeltShareButton.defaultProps = {
  collectionImageSrc: null,
  email: false,
  hrefPath: typeof window !== 'undefined' ? window.location.href : '',
  pinterestTitle: typeof document !== 'undefined' ? document.title : '',
};

export default ShareBeltShareButton;
